import script from "./BreadcrumbsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadcrumbsBar.vue?vue&type=script&setup=true&lang=js"

import "./BreadcrumbsBar.vue?vue&type=style&index=0&id=ed8ffff2&lang=scss"

const __exports__ = script;

export default __exports__